import React from 'react';
import { AdminAuthProvider, useAdminAuth } from '../context/AdminAuthContext';
import AdminLogin from '../components/AdminLogin';
import AdminDashboard from '../components/AdminDashboard';

const AdminGate = () => {
  const { isAuthed } = useAdminAuth();
  return isAuthed ? <AdminDashboard /> : <AdminLogin />;
};

const AdminPage = () => (
  <AdminAuthProvider>
    <AdminGate />
  </AdminAuthProvider>
);

export default AdminPage;
